import { useState, useEffect } from 'react';
import { searchCampaignsByPrefix } from '../services/campaignSearchService';

const DEBOUNCE_MS = 300;

/**
 * Debounced Firestore prefix search for campaigns.
 *
 * @param {string} companyId - From businessProfile.id
 * @returns {{ searchTerm: string, setSearchTerm: Function, results: Array, isLoading: boolean }}
 */
export function useCampaignSearch(companyId) {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!searchTerm.trim() || !companyId) {
      setResults([]);
      setIsLoading(false);
      return;
    }

    const timer = setTimeout(async () => {
      setIsLoading(true);
      try {
        const campaigns = await searchCampaignsByPrefix(companyId, searchTerm);
        setResults(campaigns);
      } catch (err) {
        setResults([]);
      } finally {
        setIsLoading(false);
      }
    }, DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [searchTerm, companyId]);

  return { searchTerm, setSearchTerm, results, isLoading };
}
